import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  query mediaRevisionList($mediaId: String!) {
    revisions: mediaRevisionList(mediaId: $mediaId) {
      ...MediaRevisionFragment
    }
  }
`
